import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { StatusApproval } from '../../../shared/enums/StatusApproval';
import { Approval } from '../../../models/Approval.model';
import { ContractType } from '../../../shared/enums/ContractType';
import { CommonHelper } from '../../../shared/helpers/CommonHelper';
import { Router } from '@angular/router';
import { LocalStorage } from "../../../shared/wrappers/LocalStorage";
import { ToastsManager } from 'ng2-toastr';
import { GUARDS } from '../../../shared/auth/Roles';

@Component({
  selector: 'app-project-listing',
  templateUrl: './project-listing.component.html',
  styleUrls: ['./project-listing.component.scss']
})
export class ProjectListingComponent implements OnInit {

  @Input() approvals;
  @Input() approvalsSearch;
  @Input() currentPage;
  @Input() totalItems;
  @Output() downloadApprovalInvoice: EventEmitter<any> = new EventEmitter();
  currentUser;
  showValue: boolean = true;

  constructor(
    public toastr:ToastsManager,
    public router: Router,
    private LocalStorage: LocalStorage,
    public commonHelper:CommonHelper) { }

  ngOnInit() {
    this.currentUser = this.LocalStorage.retrieve('user')
    if (this.currentUser.permission === GUARDS.BUSINESSPARTNER) {
        this.showValue = false;
    }
  }


    verifyColorColumn(status: number) {
        let cssClass = "";
        if (status == StatusApproval.Paid)
            cssClass = "pago";

        if (status == StatusApproval.PendingApproval)
            cssClass = "aprovacao-pendente";

        if (status == StatusApproval.PendingPayment)
            cssClass = "pagamento-pendente";

        if (status == StatusApproval.AwaitingRational)
            cssClass = "aguardando-racional";

        return cssClass;

    }

    buldContractType(approval: Approval) {
        let type = approval.consultant.contract.kind;
        let honor = approval.consultant.contract.honorarium;

        let transcriptType = this.commonHelper.transcriptContractType(type);
        let transcriptHonor = this.commonHelper.transcriptHonorariumType(honor);

        if (type === ContractType.PJ)
            return `${transcriptType} (${transcriptHonor})`;

        return `${transcriptType}`;
    }

    getTotalValue(approval){
      let hours = approval.projects.total_hours,
          value = approval.consultant.contract.hourValue;
      return (Math.ceil(hours * value )).toFixed(2);
    }

    downloadInvoice(approval){
        this.downloadApprovalInvoice.emit(approval);
    }

    hasPermission(approval: Approval): void {
        const permissionRoles = [GUARDS.MANAGER, GUARDS.FINANCES, GUARDS.GOVERNANCE, GUARDS.ACCOUNTING]
        const currentUser = this.LocalStorage.retrieve('user')

        if (currentUser.isGovernanceMaster) {
            this.router.navigate([`/approvals/approvals-edit/${approval._id}`])
            return
        }

        if(!permissionRoles.includes(currentUser.permission)) {
            this.toastr.warning('Você não possui permissão para acessar esta aprovação', 'Operação bloqueada')
            return
        }

        const approvalExcellenceCenterId = approval.consultant.excellenceCenter ? approval.consultant.excellenceCenter._id : ''
        const outOfCenterRoles = [GUARDS.FINANCES, GUARDS.ACCOUNTING];
        if(!outOfCenterRoles.includes(this.currentUser.permission) && (!currentUser.excellenceCenters || !currentUser.excellenceCenters.find(({ _id }) => _id === approvalExcellenceCenterId))) {
            this.toastr.warning('Você não possui permissão para acessar esta aprovação', 'Operação bloqueada')
            return
        }
        this.router.navigate([`/approvals/approvals-edit/${approval._id}`])
    }
}



// WEBPACK FOOTER //
// ./src/app/views/approvals/project-listing/project-listing.component.ts